<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '90vw', height: '90vh'}"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onHide()"
  styleClass="p-dialog-mappa-scheda">

  <ng-template pTemplate="header">
    <div class="p-dialog-header">
      <span class="material-icons" style="vertical-align: middle; margin-right: 8px; font-size: 28px;">map</span>
      <span>{{ titolo }}</span>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="map-container">
      <div #map class="map"></div>
    </div>
  </ng-template>
</p-dialog>
